import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isMarketTime } from '@/utils/date-calculations';

export function useFeedStatus() {
  const { activeSubscription, brokerLoggedIn } = useSelector((s) => s.auth);
  const { holidays, specialSessions } = useSelector((s) => s.market);
  
  const isLiveFeedActive = !!(activeSubscription && brokerLoggedIn);

  const [isMarketOpen, setIsMarketOpen] = useState(() => 
    isMarketTime(holidays, specialSessions)
  );

  useEffect(() => {
    const checkMarketStatus = () => {
      const open = isMarketTime(holidays, specialSessions);
      setIsMarketOpen(open);
    };
    
    checkMarketStatus();
    const id = setInterval(checkMarketStatus, 30_000);
    return () => clearInterval(id);
  }, [holidays, specialSessions]);

  return {
    isLiveFeedActive,
    isMarketOpen,
  };
}
